import { i18n } from '@/plugins/i18n'
import { collectiveStatusStr, collectiveVariant } from '@/constants/collectiveStatus'

export default [
    {
        field: 'id',
        title: '#',
        sortable: true,
        width: 70,
        type: 'number',
        selector: false,//{class: 'kt-checkbox--solid'},
        textAlign: 'center',
    },
    {
        field: 'full_name',
        title: i18n.t('label.user_full_name'),
        sortable: false,
        template: (row) => {
            return '<a href="/users/' + row.user.id + '/details">'+row.user.full_name+'</a>'
        },
    },
    {
        field: 'gateway',
        title: i18n.t('label.gateway'),
        template: (row) => {
            if (row.gateway.type == 0)
                return '<a href="/gateway/starshop-gateways/' + row.gateway.id + '/details">'+row.gateway.farsi_name+'</a>'
            else
                return '<a href="/dedicated/' + row.gateway.id + '/details">'+row.gateway.farsi_name+'</a>'
        },
        sortable: true,
    },
    {
        field: 'site_address',
        title: i18n.t('label.site_address'),
        sortable: false,
        template: (row) => '<span dir="ltr">'+row.gateway.website_address+'</span>',
        width: 120
    },
    {
        field: 'collective_shop_name',
        title: i18n.t('label.dedicated_shop_name'),
        sortable: false,
        template: (row) => {
            if (row.dedicated_shop === i18n.t('label.public')) {
                return '<span dir="ltr">' + i18n.t('label.public') + '</span>'
            } else return '<a href="/dedicated/' + row.dedicated_shop.id + '/details">' + row.dedicated_shop.farsi_name + '</a>'
        },
        width: 120
    },
    {
        field: 'status',
        sortable: true,
        title: i18n.t('label.status'),
        template: (row) => {
            let status  = collectiveStatusStr.get(row.status)
            let variant = 'badge-'+collectiveVariant(row.status)

            return '<div class="badge '+variant+' text-white">'+ status+'</div>'
        },
        width: 80
    },
]